import { useState } from "react";
import MobileNavbar from "./MobileNavbar";

const MobileHeaderDropdownMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button
        className="flex flex-col justify-center items-center w-8 h-8 p-1.5 gap-1.5 transition-all duration-300 hover:bg-[#22C8BF]/10"
        onClick={toggleMenu}
      >
        <span className={`w-full h-[2px] bg-[#22C8BF] transform transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-[7px]' : ''}`} />
        <span className={`w-full h-[2px] bg-[#22C8BF] transition-all duration-300 ${isOpen ? 'opacity-0' : 'opacity-100'}`} />
        <span className={`w-full h-[2px] bg-[#22C8BF] transform transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-[7px]' : ''}`} />
      </button>
      <MobileNavbar show={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default MobileHeaderDropdownMenu;
